import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@tameeni/icons";
import { cn } from "@tameeni/shared-logic";
function PriceLabel({
  className,
  symbolClassName,
  amount,
  isReversed
}) {
  return /* @__PURE__ */ jsxs(
    "p",
    {
      className: cn(
        "flex items-center gap-1",
        isReversed && "flex-row-reverse",
        className
      ),
      children: [
        /* @__PURE__ */ jsx("span", { className: "ltr:order-2 rtl:order-1", children: amount }),
        /* @__PURE__ */ jsx("span", { className: "ltr:order-1 rtl:order-2", children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "SaudiRiyalSymbol",
            className: cn("size-3 ", symbolClassName)
          }
        ) })
      ]
    }
  );
}
PriceLabel.displayName = "PriceLabel";
export {
  PriceLabel
};
